import React, { PureComponent } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { groupBy } from 'lodash';
import { get, post, put } from '../../redux/modules/services';
import FieldInput from '../../components/Field/Field';
import Image from '../../components/image/Image';
import Editor from '../../components/editor/Editor';
import DynamicField from '../../components/dynamic-field';
import * as Validations from '../../validations/validations';

const FORM_NAME = 'PartnerForm';

class PartnerForm extends PureComponent {

  mapSections = (sections = []) => {
    const backup = sections.map((obj, index) => {
      obj.position = index;
      return obj
    });
    const result = groupBy(backup, 'component');

    return {
      section_images: result.Image || [],
      section_texts: result.Text || [],
      section_lists: result.List || []
    }
  };


  handlerSubmit(values = {}) {
    const { getAction, putAction, postAction, close } = this.props;
    const sectionsObj = this.mapSections(values.sections);
    const newData = { ...values, ...sectionsObj };
    if (newData.id > 0) {
      return putAction(newData.id, newData)
        .then(() => {
          close();
          getAction();
        });
    }
    return postAction(newData).then(() => {
      close();
      getAction();
    });
  }

  render() {
    const { myValues, handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <form
        className="planet-form services-form"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <div className="planet-form__container">
          <div className="row">
            <div className="col-xs-7">
              <Field
                label="Title"
                name="title"
                validate={[Validations.required, Validations.minLength2]}
                component={FieldInput}/>
              <Field
                name="body"
                validate={[Validations.required, Validations.minLength2, Validations.maxMediumText]}
                component={Editor}/>
            </div>
            <div className="col-xs-5">
              <Field
                label="Image"
                validate={[Validations.required, Validations.minLength2]}
                name="image"
                component={Image}/>
            </div>
          </div>

          <div className="services-form__sections">
            <DynamicField myValues={myValues}/>
          </div>

          <div className="col-lg-12 text-right form-buttons">
            <button
              disabled={pristine || submitting}
              loading={submitting}
              type="submit"
              className="btn btn-primary btn-xl">Save
            </button>

            <button
              disabled={pristine || submitting}
              loading={submitting}
              type="button"
              className="btn btn-primary btn-xl"
              onClick={reset}>Clear
            </button>
          </div>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      postAction: post,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/service-form/ServiceForm.js